module.exports = __webpack_public_path__ + "img/banner1.8a543142.jpg";